import React, { useContext } from "react";
import SelectionItem from "../../SelectionItem";
import ImgEsteticCustom from "./images/esteticCustom.png";
import ImgEsteticTypical from "./images/esteticTypical.png";
import "./index.scss";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const EsteticSelect = ({
  selectStep
}) => {
  const {
    _t
  } = useTranslation();
  const {
    toggleBottomBarInfo
  } = useContext(StepContext);
  const types = [{
    key: "esCustomVeneers",
    aboutKey: "esCustomSelect",
    img: ImgEsteticCustom,
    name: _t("Произвольный выбор реставраций"),
    description: _t("Данный путь позволяет самостоятельно составить план эстетической реабилитации и изучить варианты типов реставраций...")
  }, {
    key: "esTypicalSelect",
    aboutKey: "esTypicalSelect",
    img: ImgEsteticTypical,
    name: _t("Выбор реставраций по типу улыбки"),
    description: _t("Эта опция предлагает готовые варианты решений, которые могут быть актуальны для разных типов улыбки...")
  }];

  function setStep(key) {
    selectStep(key);
  }

  function openBottomBar(type) {
    toggleBottomBarInfo(true, type);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "esteticSelect"
  }, /*#__PURE__*/React.createElement("div", {
    className: "esteticSelect-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    itemKey: el.aboutKey,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    outerTitle: el.name,
    outerDescription: el.description,
    aboutClick: () => openBottomBar(el.aboutKey)
  }))));
};

export default EsteticSelect;